import {
  CircleIndicatorWrp,
  LegendHexagonBody,
  LegendHexagonLeft,
  LegendHexagonRight,
  LegendInnerWrapper,
  LegendMainContainer,
  LegendMainContainerType2,
  LegendMainWraper,
  LegendType2Wrp,
  ResetButton,
  ResetButtonWrapper,
  TextWrapper,
  ValueWrapper,
  ValueWrp,
  IconWrapper,
  LegendTitle,
} from "../hexagon.styled";
import { viewSizeCalculator } from "../../../../../utils";
import partnerIcon from "../../../../../Assets/Icons/PartnerLocation.svg";

// "P" partner-location badge legend item, matching the Figma partner icon.
const PartnerLegendItem = ({
  label,
  size2 = 0,
  isSelected = true,
  onClick,
}) => {
  const swatch = viewSizeCalculator(1.25);
  return (
    <LegendMainWraper
      isSelected={isSelected}
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      <img
        src={partnerIcon}
        alt="Partner Location"
        style={{ width: swatch, height: swatch, flexShrink: 0 }}
      />
      <LegendHexagonBody isSmallerHex={true} size2={size2}>
        <TextWrapper>{label}</TextWrapper>
      </LegendHexagonBody>
    </LegendMainWraper>
  );
};

const Legends = ({
  data = {},
  size = 6,
  handleLegendFn,
  labelFontSize,
  LegendType,
  legendClickedValue,
  handleReset,
  loading,
  partnerExclusiveFlag = true,
}) => {
  const hexagonHeight = size * Math.sqrt(3);
  const size2 = size - 1.15;

  return (
    <>
      {loading ? (
        <LegendMainContainer>
          <LegendTitle loading={loading} size={size}>
            {!loading && "Case density:"}
          </LegendTitle>
          {Object.keys(data).map((item) => (
            <LegendMainWraper key={item}>
              <LegendTitle loading={loading} size={size}>
                {!loading && "Case density:"}
              </LegendTitle>
            </LegendMainWraper>
          ))}
        </LegendMainContainer>
      ) : (
        <LegendMainContainer>
          <LegendTitle>Case Density (/100k pop):</LegendTitle>
          {Object.keys(data).map((item) => {
            const color = data[item]?.color;
            const value = data[item]?.value;
            // The partner entry highlights all partner (ESA) regions on click.
            // Hide it when Partner ESA is excluded, since no partner hospitals
            // are shown in that state.
            if (item === "partner") {
              if (!partnerExclusiveFlag) return null;
              const isPartnerSelected =
                legendClickedValue === false
                  ? true
                  : legendClickedValue === "partner";
              return (
                <PartnerLegendItem
                  key={item}
                  size2={hexagonHeight}
                  isSelected={isPartnerSelected}
                  onClick={() => handleLegendFn("partner")}
                  label={data[item]?.label || "Partner Location"}
                />
              );
            }
            const isLegendSelected =
              legendClickedValue === false ? true : legendClickedValue === item;
            return (
              <LegendMainWraper
                key={item}
                onClick={() => handleLegendFn(item)}
                isSelected={isLegendSelected}
              >
                <LegendHexagonRight
                  size={size}
                  size2={hexagonHeight}
                  color={color}
                />
                <LegendHexagonBody
                  isSmallerHex={true}
                  LegendType={LegendType}
                  size={size * 12}
                  size2={hexagonHeight}
                  color={color}
                >
                  <TextWrapper labelFontSize={labelFontSize}>
                    {item}: {item === 'low' ? '<400' : item === 'medium' ? '400 - 470' : '>470'}
                  </TextWrapper>
                </LegendHexagonBody>
              </LegendMainWraper>
            );
          })}
        </LegendMainContainer>
      )}
    </>
  );
};

export default Legends;
